export default __webpack_public_path__ + "static/media/play-light.10ce1fa3.svg";